export default "__VITE_ASSET__b4c5e7f5__"